import React from 'react';
import Main from './components/MainComponent'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import './App.css';

function App() {
  const theme = createTheme({
  typography: {
    fontFamily: "'Source Sans 3', sans-serif", // Set Raleway as the default font
    body2: {
      fontFamily: "'Source Sans 3', sans-serif",
      fontWeight: 500, // Regular weight
    },
    body1: {
      fontFamily: "'Source Sans 3', sans-serif",
      fontWeight: 500, // Regular weight
    },
    h4: {
      fontFamily: "'Source Sans 3', sans-serif",
      color: '#124e8f',
      fontWeight: 'bold'
    },
    h1: {
      fontFamily: "'Source Sans 3', sans-serif",
    },
    h5: {
      fontFamily: "'Source Sans 3', sans-serif",
      color: '#35526e',
      fontWeight: 'bold'
    },
    h6: {
      fontFamily: "'Source Sans 3', sans-serif",
      color: '#ffffff',
      fontWeight: 'bold'
    },
  },
  palette: {
    background: {
      default: '#ffffff',
    },
    text: {
      primary: '#35526e',
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Source Sans 3', sans-serif",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Source Sans 3', sans-serif",
          textTransform: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: "'Source Sans 3', sans-serif",
      },
    },
  },
  },
});


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Main/>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
